import { useMemo } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";

// Build a property → title lookup from the loaded column list.
// Used as a fallback in queryToPredicates (after pred.groupByTitle) so that old saved
// filters (which have no stored groupByTitle) still render clean column titles.
const usePropertyTitleLookup = (): Maybe<Map<string, string>> => {
  const categoryList = useSelector((state: RootState) => state.groupBy.categoryList);

  const propertyTitleLookup = useMemo(() => {
    const map = new Map<string, string>();
    for (const category of categoryList) {
      for (const column of category.columns) {
        map.set(column.property, column.title);
      }
    }
    return map;
  }, [categoryList]);

  return propertyTitleLookup;
};

export default usePropertyTitleLookup;
